import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import classNames from 'classnames';
import Table from '@jetbrains/ring-ui/components/table/table';
import Pager from '@jetbrains/ring-ui/components/pager/pager';
import Selection from '@jetbrains/ring-ui/components/table/selection';
import styles from '@common/tables/basic-table-view.css';
import { assignTestId } from '@common/infra/tests/assign-test-id';
export function BasicTableView({ pagerProps, tableClassName, selection, tableWrapperClassName, size = 'AUTO', ...restProps }) {
    const customSelection = useMemo(() => {
        return selection !== null && selection !== void 0 ? selection : new Selection();
    }, [selection]);
    const tableClasses = useMemo(() => classNames(styles.table, {
        [styles.tableAutoWidth]: size === 'AUTO',
        [styles.tableFullWidth]: size === 'FULL'
    }, tableClassName), [size, tableClassName]);
    return (_jsxs("div", { className: classNames(styles.tableWrapper, tableWrapperClassName), ...assignTestId('full-width-table', restProps['data-test']), children: [_jsx(Table, { ...restProps, className: tableClasses, scrollOnTableFocus: false, selection: customSelection, stickyHeader: false }), pagerProps ? _jsx(Pager, { ...pagerProps }) : null] }));
}
